const MAGIC_LINK_EMAIL_KEY = "cognito_magic_link_email";
const MAGIC_LINK_EMAIL_TTL_MS = 30 * 60 * 1000; // 30 minutes

interface MagicLinkEmailData {
  email: string;
  expiresAt: number;
}

export function setMagicLinkEmail(email: string): void {
  const data: MagicLinkEmailData = {
    email,
    expiresAt: Date.now() + MAGIC_LINK_EMAIL_TTL_MS,
  };
  localStorage.setItem(MAGIC_LINK_EMAIL_KEY, JSON.stringify(data));
}

export function getMagicLinkEmail(): string | undefined {
  const raw = localStorage.getItem(MAGIC_LINK_EMAIL_KEY);
  if (!raw) {
    return undefined;
  }

  try {
    const data: MagicLinkEmailData = JSON.parse(raw);
    if (Date.now() > data.expiresAt) {
      localStorage.removeItem(MAGIC_LINK_EMAIL_KEY);
      return undefined;
    }
    return data.email;
  } catch {
    localStorage.removeItem(MAGIC_LINK_EMAIL_KEY);
    return undefined;
  }
}

export function clearMagicLinkEmail(): void {
  localStorage.removeItem(MAGIC_LINK_EMAIL_KEY);
}
